import React from 'react'
import TableHead from '@mui/material/TableHead'
import TableSortLabel from '@mui/material/TableSortLabel';
import { TableRowStyled, TableHeadStyled } from "../styling/tableStyles";

export default function TableSortHeader(props) { 
  const { heads, order, orderBy, handleRequestSort, doNotSort } = props;
  const mheads = Array.isArray(heads[0]) ? heads : [ heads ];

  return (
    <>
      <TableHead>
        {mheads.map((hrow, r) => (
          <TableRowStyled key={r}>
            {hrow.map((th, c) => {
              if (!th.invisible) {
                const active = doNotSort ? false : orderBy === th.id || orderBy === th.altSort;
                const sx = th.hasOwnProperty("sx") ? th.sx : {};
                const rowSpan = th.hasOwnProperty("rowSpan") ? th.rowSpan : 1
                const colSpan = th.hasOwnProperty("colSpan") ? th.colSpan : 1
                if (th.id !== null) {
                  return (
                    <TableHeadStyled 
                      sortDirection={orderBy === th.id ? order : false}
                      sx={sx} 
                      rowSpan={rowSpan} 
                      key={th.id}
                    >
                        <TableSortLabel
                            active={active}
                            direction={active ? order : 'asc'}
                            hideSortIcon={true}
                            onClick={() => handleRequestSort(th.altSort || th.id)}
                          >
                            {th.text}
                        </TableSortLabel>
                    </TableHeadStyled>
                  )
                } else {
                    return (
                      <TableHeadStyled 
                        sx={sx} 
                        rowSpan={rowSpan} 
                        colSpan={colSpan} 
                        key={"c"+c}
                      >
                        {th.text}
                      </TableHeadStyled>
                    )
                }
              }
            })}
          </TableRowStyled>
        ))}
      </TableHead>
    </>
  )
}
